import script from "./Token.vue?vue&type=script&setup=true&lang=ts"
export * from "./Token.vue?vue&type=script&setup=true&lang=ts"

import "./Token.vue?vue&type=style&index=0&id=335e609b&lang=scss"

const __exports__ = script;

export default __exports__